/* stylelint-disable max-nesting-depth */
<template lang="pug">
  .filter-container
    .sorting
        button(@click="activeMain = !activeMain") Sort By: {{ activeMain ? "Date" : "Name" }}
        button(@click="activeThree = !activeThree") Order: {{ activeThree ? "Descending" : "Ascending" }}
    .hiding
        button.hidden(:class="{active:isActive}" @click="showHidden") Show Hidden
</template>

<script lang="ts" setup>
import { ref, computed, watch } from "vue";
import { useLeads } from "@/store/useLeads";

const leadsStore    =    useLeads();

const props = defineProps({
	activeToggleMain: Boolean,
	activeToggleThree: Boolean,
});

const activeMain = ref(props.activeToggleMain);
const activeThree = ref(props.activeToggleThree);

const emit = defineEmits(["sortChanged"]);

const isActive = ref(false);

const showHidden = () => {
	// leadsStore.showHidden();
	leadsStore.toggleHiddenLeads();
	isActive.value = !isActive.value;
};

const sortBy = () => {
	const sortedList = [...useLeads().leadsList];

	if (activeMain.value) {
		sortedList.sort((a, b) =>
			(activeThree.value
				? new Date(a.lastContact).getTime() - new Date(b.lastContact).getTime()
				: new Date(b.lastContact).getTime() - new Date(a.lastContact).getTime())
		);
	} else {
		sortedList.sort((a, b) =>
			a.name.fullName.localeCompare(b.name.fullName)
		);

		if (activeThree.value) sortedList.reverse();
	}

	emit("sortChanged", sortedList);
};

watch([activeMain, activeThree], sortBy);
</script>

<style lang="scss">
.filter-container {
    position: sticky;
    background-color: $color-gray-26;
    display: flex;
    align-items: center;
    margin-inline: unset;
    justify-content: space-between;
    height: 4em;
    padding: 0 4em;
    .hiding {

        .hidden {
            border: none;
            background: none;
            cursor: pointer;
            margin: 0;
            padding: 0;
            color: #FFFFFF60;
        }
        .hidden.active {
            color: #FFFFFF;
        }
    }
}
</style>